import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import ApiService from '../../../services/apiService';
import { toast } from 'react-toastify';
import { RxCross1 } from 'react-icons/rx';
import { useSelector, useDispatch } from 'react-redux';
import { setRows, addRow, removeRow, removeSingleRow, updateRow, clearRows } from '../../../../Redux/actions/rowActions';
import { IoAddSharp } from 'react-icons/io5';
import { BarLoader } from 'react-spinners';
import AsyncSelect from 'react-select/async';
import { computeLineFinancials, getMoneyPrecision } from '../poItemGridUtils';
import '../poItemGrid.css';

const ItemGridTwo = ({
  apiData,
  onRequisitionData,
  setLoader,
  loder,
  itemData,
  itemList,
  pendingOnlyMode = false,
  selectedCheck,
  handleVatChange,
  currencyPrecision,
  setOverallDiscount, grandTotal, setVatAmount, vatAmount,
  overallDiscount, setDiscountAmount, discountAmount, setGrandTotal
}) => {
  const rows = useSelector((state) => state.rows.rows);
  const [itemOptions, setItemOptions] = useState([]);
  const [descriptionOptions, setDescriptionOptions] = useState([]);
  const [vat, setvat] = useState([]);
  const dispatch = useDispatch();
  const apiService = new ApiService();
  const [page, setPage] = useState(1);
  const [desPage, setDecPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loader, setLoaders] = useState(false);

  const calculatedTotal = rows.reduce((sum, row) => sum + (parseFloat(row?.amount - row?.vatAmount) || 0), 0);
  useEffect(() => {
    if (rows[0]?.ItemNo) {
      updatevat();
    }
  }, [selectedCheck]);
  // Replace the existing useEffects in ItemGrid with these:

  useEffect(() => {
    fetchItemNo('', 1);
    fetchItemDesc('', 1);
    getVat();
  }, []);

  // Clear rows when itemData changes (important for dropdown changes)
  useEffect(() => {
    if (itemData?.requisitionNo && !itemList?.applyKey) {
      dispatch(clearRows());
    }
  }, [itemData?.requisitionNo, itemList?.applyKey]);

  useEffect(() => {
    if (itemList?.applyKey) {
      getItems();
      return;
    }
    if (itemData?.requisitionNo) {
      getItems();
    }
  }, [itemList?.applyKey, itemData?.requisitionNo, selectedCheck]);

  // Update VAT when selectedCheck changes
  useEffect(() => {
    if (rows.length > 0 && rows[0]?.ItemNo) {
      updatevat();
    }
  }, [selectedCheck]);
  useEffect(() => {
    const total = rows.reduce(
      (sum, row) => sum + Number(row?.amount || 0),
      0
    );

    const vat = rows[0]?.vat

    const discountAmt = (calculatedTotal * overallDiscount) / 100;
    let afterdiscount = (calculatedTotal - discountAmt)
    const vatAmt = (afterdiscount * vat) / 100;

    setDiscountAmount(discountAmt);
    setGrandTotal(afterdiscount + vatAmt);
    setVatAmount(vatAmt)
  }, [rows, overallDiscount]);
  const updatevat = async () => {
    try {
      let vatParam = `?toPurchase=true`;
      const vat = await apiService.getApiParamater('GET_INV_TAX', vatParam);
      setvat(vat.data.result);
      const updatedRows = rows.map((row) => ({ ...row }));
      const apiPromises = updatedRows.map(async (row, index) => {
        const selectedVat = vat.data.result?.find((tax) => tax.description === row?.vatDec);
        let amount = row?.qty * row?.baseAmount;
        const perAmount = (amount / 100) * (selectedVat?.rate || 0);
        let excludedAmount = amount + perAmount;
        const calculatedAmount = selectedCheck ? excludedAmount : amount;
        let discountamount = row?.discount;
        let finalAmount = calculatedAmount;
        updatedRows[index].calculatedAmount = calculatedAmount;
        updatedRows[index].amount = finalAmount;
        updatedRows[index].vat = selectedVat?.rate || 0;
        updatedRows[index].vatDec = selectedVat?.description || 0;
        updatedRows[index].vatAmount = perAmount;
        updatedRows[index].discountAmount = discountamount;
        updatedRows[index].discount = row?.discount;
      });
      await Promise.all(apiPromises);
      setRows(updatedRows);
      onRequisitionData(updatedRows);
      dispatch(setRows(updatedRows));
    } catch (error) {
      console.error('Error updating rows with new stock:', error);
    }
  };
  const getVat = async () => {
    let vatParam = `?toPurchase=true`;
    const vat = await apiService.getApiParamater('GET_INV_TAX', vatParam);
    setvat(vat.data.result);
  };
  const buildPendingGridRows = async (pendingList, vatResult) => {
    const formattedRowsPromises = (pendingList?.items || []).map(async (detail) => {
      let selecteditem = null;
      try {
        const params = new URLSearchParams();
        params.append('ItemNo', detail.itemCode || '');
        const response = await apiService.getApiParamater('GET_ITEM', `?${params.toString()}`);
        selecteditem = response?.data?.result?.[0];
      } catch (err) {
        console.warn(`GET_ITEM failed for ${detail.itemCode}`, err);
      }

      const qty = parseFloat(detail?.qty ?? detail?.balQty) || 0;
      const fin = computeLineFinancials({
        qty: detail?.qty ?? detail?.balQty,
        unitPrice: detail?.price ?? detail?.unitPrice,
        vatList: vatResult,
        vatDesc: detail?.vatDesc,
        vatPerc: detail?.vatPerc,
        vatAmountFromApi: detail?.vatAmount,
        discount: detail?.discount ?? 0,
        selectedCheck,
        itemMasterVat: selecteditem?.vat,
        currencyPrecision,
      });

      const conv = selecteditem?.convToInvUOM || 1;
      return {
        requisitionNo: detail?.requisitionNo || pendingList.requisitionNo || '',
        srno: detail?.srno,
        ItemNo: detail.itemCode,
        itemDescription: detail?.itemDescription,
        qty,
        stock: conv * qty,
        baseQty: conv,
        uom: detail?.uom ?? detail?.baseUOM,
        baseAmount: Number(detail?.price ?? detail?.unitPrice ?? 0).toFixed(currencyPrecision),
        specification: detail?.specification ?? '',
        amount: fin.amount,
        vat: fin.vatRate,
        vatDec: fin.vatDec,
        vatAmount: fin.vatAmount,
        discount: fin.discount,
        calculatedAmount: fin.calculatedAmount,
        discountAmount: fin.discountAmount,
      };
    });

    return (await Promise.all(formattedRowsPromises)).filter(Boolean);
  };
  const getItems = async () => {
    try {
      let vatParam = `?toPurchase=true`;
      const vat = await apiService.getApiParamater('GET_INV_TAX', vatParam);
      setvat(vat.data.result);
      if (itemData?.requisitionNo) {
        setLoader(true);
        let param = `?Id=${itemData?.requisitionNo}`;
        const response = await apiService.getApiParamater('GET_PR', param);
        const selectedPR = response?.data?.result[0];
        if (!selectedPR) {
          console.error('Selected PR not found');
          return;
        }

        const prDetails = selectedPR?.prDetails || [];
        const sortedPrDetails = [...prDetails].sort((a, b) => a.srno - b.srno);
        debugger
        const formattedRowsPromises = prDetails?.map(async (detail, index) => {
          debugger
          const params = new URLSearchParams();
          params.append('ItemNo', detail.itemCode || '');
          const response = await apiService.getApiParamater('GET_ITEM', `?${params.toString()}`);
          let selecteditem = response?.data?.result[0];
          const selectedItem = rows?.find((item) => item?.itemDescription === detail?.itemDescription);
          const selectedPritem = sortedPrDetails[index];
          const selectedVat = vat.data.result?.find((tax) => tax?.description === selecteditem?.vat);
          debugger
          if (!selecteditem) {
            console.error(`Selected item with description ${detail?.itemDescription} not found`);
            return null;
          }
          let amount = detail?.qty * detail.unitPrice;
          const perAmount = (amount / 100) * selectedVat?.rate;
          let excludedAmount = amount + perAmount;
          const calculatedAmount = selectedCheck ? excludedAmount : amount;
          let discountamount = detail?.discount;
          let finalAmount = calculatedAmount - (selectedItem?.discount || 0);
          return {
            requisitionNo: itemData.requisitionNo || '',
            srno: selectedPritem?.srno,
            ItemNo: detail.itemCode,
            itemDescription: detail?.itemDescription,
            qty: detail?.qty,
            stock: selecteditem.convToInvUOM * detail?.qty,
            baseQty: selecteditem.convToInvUOM,
            uom: detail?.uom,
            baseAmount: detail.unitPrice?.toFixed(currencyPrecision || 3),
            specification: selectedPritem ? selectedPritem?.specification : '',
            amount: finalAmount?.toFixed(currencyPrecision || 3),
            vat: selectedVat?.rate || 0,
            vatDec: selectedVat?.description,
            vatAmount: perAmount?.toFixed(currencyPrecision || 3),
            discount: selectedItem?.discount,
            calculatedAmount: calculatedAmount?.toFixed(currencyPrecision || 3),
            discountAmount: discountamount?.toFixed(currencyPrecision || 3),
          };
        })
          .filter((row) => row !== null);
        const formattedRows = await Promise.all(formattedRowsPromises);
        if (formattedRows?.length > 0) {
          setLoader(false);
          setRows(formattedRows);
          onRequisitionData(formattedRows);
          dispatch(setRows(formattedRows));
        }
      } else {
        setLoader(true);

        const formattedRowsPromises = itemData?.poDetails
          ?.map(async (detail, index) => {
            const params = new URLSearchParams();
            params.append('ItemNo', detail.itemCode || '');
            const response = await apiService.getApiParamater('GET_ITEM', `?${params.toString()}`);
            let selecteditem = response?.data?.result[0];

            const selectedItem = rows?.find((item) => item?.itemDescription === detail?.itemDescription);
            const selectedVat = vat.data.result?.find((tax) => tax?.description === selecteditem?.vat);
            let amount = detail?.qty * detail.unitPrice;
            const perAmount = (amount / 100) * selectedVat?.rate;
            let excludedAmount = amount + perAmount;
            const calculatedAmount = selectedCheck ? excludedAmount : amount;
            let discountamount = detail?.discount;
            let finalAmount = calculatedAmount - (selectedItem?.discount || 0);
            return {
              requisitionNo: itemData?.requisitionNo || '',
              srno: detail?.srno,
              ItemNo: detail.itemCode,
              itemDescription: detail?.itemDescription,
              qty: detail?.qty,
              stock: selecteditem.convToInvUOM * detail?.qty,
              baseQty: selecteditem.convToInvUOM,
              uom: detail?.uom,
              baseAmount: detail.unitPrice?.toFixed(currencyPrecision || 3),
              specification: detail ? detail?.specification : '',
              amount: finalAmount?.toFixed(currencyPrecision || 3),
              vat: selectedVat?.rate || 0,
              vatDec: selectedVat?.description,
              vatAmount: perAmount?.toFixed(currencyPrecision || 3),
              discount: selectedItem?.discount,
              calculatedAmount: calculatedAmount?.toFixed(currencyPrecision || 3),
              discountAmount: discountamount?.toFixed(currencyPrecision || 3),
            };
          })
          .filter((row) => row !== null);
        const formattedRows = await Promise.all(formattedRowsPromises);
        if (formattedRows?.length > 0) {
          setLoader(false);
          setRows(formattedRows?.reverse());
          onRequisitionData(formattedRows);
          dispatch(setRows(formattedRows));
        }
      }
    } catch (error) {
      setLoader(false);
      console.error('Error fetching items:', error);
    }
  };
  const fetchItemNo = async (inputValue = '', pageNumber = 1) => {
    if (loader) return;
    setLoaders(true);
    try {
      const apiService = new ApiService();
      const params = new URLSearchParams();
      params.append('PageNo', pageNumber || 1);
      params.append('PageSize', 20);
      params.append('ItemNo', inputValue || '');
      const response = await apiService.getApiParamater('GET_ITEM', `?${params.toString()}`);
      const fetchedItems = response.data.result.map((item) => ({
        label: item.itemNo,
        value: item,
      }));
      if (fetchedItems.length < 20) setHasMore(false);
      setItemOptions((prevAccounts) => [...prevAccounts, ...fetchedItems]);
      setLoaders(false);
      return fetchedItems;
    } catch (error) {
      console.error('Error fetching account data:', error);
      setLoaders(false);
      return [];
    }
  };
  const fetchItemDesc = async (inputValue = '', pageNumber = 1) => {
    if (loader) return;
    setLoaders(true);
    try {
      const apiService = new ApiService();
      const params = new URLSearchParams();
      params.append('PageNo', pageNumber || 1);
      params.append('PageSize', 20);
      params.append('ItemDescription', inputValue || '');
      const response = await apiService.getApiParamater('GET_ITEM', `?${params.toString()}`);
      const fetchedItems = response.data.result.map((item) => ({
        label: item.itemDescription,
        value: item,
      }));
      if (fetchedItems.length < 20) setHasMore(false);
      setDescriptionOptions((prevAccounts) => [...prevAccounts, ...fetchedItems]);
      setLoaders(false);
      return fetchedItems;
    } catch (error) {
      console.error('Error fetching account data:', error);
      setLoaders(false);
      return [];
    }
  };
  const loadOptions = async (inputValue, callback) => {
    const options = await fetchItemNo(inputValue, 1);
    callback(options);
  };
  const loadDescOptions = async (inputValue, callback) => {
    const options = await fetchItemDesc(inputValue, 1);
    callback(options);
  };
  const loadMoreOptions = async () => {
    if (!hasMore || loader) return;
    setPage((prevPage) => prevPage + 1);
    await fetchItemNo('', page + 1);
  };
  const loadMoreDescOptions = async () => {
    if (!hasMore || loader) return;
    setDecPage((prevPage) => prevPage + 1);
    await fetchItemDesc('', desPage + 1);
  };
  const handleInputChange = async (index, fieldName, value) => {
    const DB = localStorage.getItem('DataBase');
    const companies = JSON.parse(localStorage.getItem('UserCompanies') || '[]');
    const defaultCompany = companies.find((comp) => comp.dataDB === DB);
    const companyName = defaultCompany?.companyName?.toUpperCase() || '';
    const isYusuf = companyName.includes('KANOO') || companyName.includes('ACCOUNTCODE');

    if (isYusuf === false) {
      const isDuplicate = rows.some((row, rowIndex) => rowIndex !== index && (row.itemNo === value || row.itemDescription === value));
      if (isDuplicate) {
        toast.error('Please choose a different item.');
        return;
      }
    }
    if (fieldName === 'qty' && value < 0) {
      toast.warning('Quantity cannot be less than 0.');
      return;
    }
    const updatedRows = rows
      ?.map(async (row, rowIndex) => {
        if (rowIndex === index) {
          const updatedRow = { ...row, [fieldName]: value, srno: ('0' + (index + 1)).slice(-2) };
          if (fieldName === 'qty') {
            const quantity = parseFloat(value);
            if (quantity < 0) {
              toast.warning('Quantity cannot be less than 0.');
              return;
            }
          }
          if (fieldName === 'ItemNo') {
            const getunit = await apiService.getApiParamater('GET_ITEM_PACK', `?ItemNo=${value}`);
            let selectedItem = getunit?.data?.result[0];
            const selectedVat = vat?.find((tax) => tax.description === selectedItem?.vat);
            if (selectedItem) {
              updatedRow.itemDescription = selectedItem?.itemDescription;
              updatedRow.ItemNo = selectedItem?.itemNo;
              updatedRow.requisitionNo = selectedItem?.itemDescription;
              updatedRow.uom = selectedItem.baseUnit;
              updatedRow.specification = selectedItem?.specification;
              updatedRow.vatDec = selectedVat?.description;
              updatedRow.vat = selectedVat?.rate;
              updatedRow.stock = 0;
              updatedRow.baseAmount = selectedItem?.avgPrice?.toFixed(currencyPrecision || 3) || 0;
              updatedRow.baseQty = parseFloat(selectedItem.convToInvUOM);
            }
          } else if (fieldName === 'itemDescription') {
            const selectedItm = descriptionOptions?.find((dep) => dep?.label === value);
            const getunit = await apiService.getApiParamater('GET_ITEM_PACK', `?ItemNo=${selectedItm?.value?.itemNo}`);
            let selectedItem = getunit?.data?.result[0];
            const selectedVat = vat?.find((tax) => tax.description === selectedItem?.vat);
            if (selectedItem) {
              updatedRow.specification = selectedItem?.specification;
              updatedRow.recordId = selectedItem?.itemNo;
              updatedRow.ItemNo = selectedItem?.itemNo;
              updatedRow.stock = 0;
              updatedRow.uom = selectedItem.baseUnit;
              updatedRow.baseQty = parseFloat(selectedItem.convToInvUOM);
              updatedRow.vatDec = selectedVat?.description;
              updatedRow.vat = selectedVat?.rate;
              updatedRow.baseAmount = selectedItem?.avgPrice?.toFixed(currencyPrecision || 3) || 0;
            }
          }
          if (fieldName === 'qty') {
            const quantity = parseFloat(value);
            const convrate = updatedRow?.baseQty;
            const baseQty = convrate || 1;
            updatedRow.stock = convrate * quantity || 0;
            updatedRow.baseQty = parseFloat(baseQty);
          }
          if (fieldName === 'qty' || fieldName === 'baseAmount') {
            const convrate = updatedRow?.baseQty;
            const selectedvat = updatedRow?.vatDec;
            const selectedVat = vat?.find((tax) => tax?.description === selectedvat);
            const quantity = parseFloat(updatedRow?.qty);
            const unitPrice = parseFloat(updatedRow.baseAmount || 0);
            const amount = quantity * unitPrice;
            const perAmount = (amount / 100) * selectedVat?.rate;
            const excludedAmount = amount + perAmount;
            const calculatedAmount = selectedCheck ? excludedAmount : amount;
            updatedRow.amount = calculatedAmount;
            updatedRow.stock = convrate * quantity || 0;
            updatedRow.calculatedAmount = calculatedAmount;
            updatedRow.vatAmount = perAmount;
          }
          if (fieldName === 'vat') {
            let amount = row?.qty * row?.baseAmount;
            const perAmount = (amount / 100) * (value?.rate || 0);
            let excludedAmount = amount + perAmount;
            const calculatedAmount = selectedCheck ? excludedAmount : amount;
            updatedRow.calculatedAmount = parseFloat(calculatedAmount);
            updatedRow.amount = parseFloat(calculatedAmount);
            updatedRow.vatDec = value?.description;
            updatedRow.vat = value?.rate;
            updatedRow.vatAmount = parseFloat(perAmount);
          }
          return updatedRow;
        }
        return row;
      })
      .filter((row) => row !== null);
    const formattedRows = await Promise.all(updatedRows);
    setRows(formattedRows);
    dispatch(setRows(formattedRows));
    onRequisitionData(formattedRows);
  };
  const addNewRow = () => {
    const newRow = {
      srno: '',
      ItemNo: '',
      requisitionNo: '',
      itemDescription: '',
      branch: '',
      qty: '',
      freeQty: '',
      uom: '',
      baseQty: '',
      baseAmount: '',
      amount: '',
      stock: '',
      bol: '',
    };
    dispatch(addRow(newRow));
    const updatedRows = [...rows, newRow];
    onRequisitionData(updatedRows);
    dispatch(setRows(updatedRows));
  };
  const handleRemoveRow = (index) => {
    dispatch(removeSingleRow(index));
    const updatedRows = rows
      .filter((_, i) => i !== index)
      .map((row, i) => ({
        ...row,
        srno: i + 1,
      }));
    onRequisitionData(updatedRows);
    dispatch(setRows(updatedRows));
  };
  const preventNegativeSign = (e) => {
    if (e.key === '-' || e.key === '+') {
      e.preventDefault();
    }
  };
  const handleOverallDiscount = (e) => {
    const percentage = Number(e.target.value) || 0;

    if (percentage > 100) {
      toast.warning("Discount percentage cannot exceed 100%");
      return;
    }

    const total = rows.reduce(
      (sum, row) => sum + Number(row?.amount - row?.vatAmount || 0),
      0
    );
    const vat = rows[0]?.vat
    const discountAmt = (total * percentage) / 100;

    if (discountAmt > total) {
      toast.warning("Discount amount cannot exceed total amount");
      return;
    }
    let afterdiscount = (total - discountAmt)
    const vatAmt = (afterdiscount * vat) / 100;
    debugger
    setOverallDiscount(percentage);
    setDiscountAmount(discountAmt);
    setGrandTotal(afterdiscount + vatAmt);
    setVatAmount(vatAmt)
  };
  return (
    <div>
      <div className="row mb-3">
        <div className="col-md-4">
          <label>Discount %</label>
          <input
            type="number"
            className="form-Input w-100"
            min="0"
            max="100"
            value={overallDiscount}
            onChange={handleOverallDiscount}
          />
        </div>
      </div>
      <div className="table-container p-2 mb-5" style={{ overflowX: 'auto', height: '400px' }}>
        {itemData ? (
          <>
            {loder === true ? (
              <div className="center p-5">
                <BarLoader color="#6E5199" size={50} height={3} width={300} />
              </div>
            ) : (
              <table className="po-item-grid-table">
                <thead className="dynoTable">
                  <tr>
                    <th className="po-item-grid-col-action"></th>
                    <th className="po-item-grid-col-srno">Sr no</th>
                    <th className="po-item-grid-col-itemno">Item No</th>
                    <th className="po-item-grid-col-desc">Description</th>
                    <th className="po-item-grid-col-specs">Item Specs</th>
                    <th className="po-item-grid-col-qty">Qty</th>
                    <th className="po-item-grid-col-uom">Packing UOM</th>
                    <th className="po-item-grid-col-stock">Inventory Qty</th>
                    <th className="po-item-grid-col-price">Unit Price</th>
                    <th className="po-item-grid-col-vat">VAT %</th>
                    <th className="po-item-grid-col-vatamt">VAT Amount</th>
                    <th className="po-item-grid-col-amount">Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {Array.isArray(rows) &&
                    [...rows] // clone to avoid mutating state
                      .sort((a, b) => Number(a.srno) + Number(b.srno))
                      .map((row, index) => (
                        <tr key={index}>
                          {itemData?.pOrderNo === itemData?.requisitionNo ? (
                            <td className="m-0 p-0" style={{ border: '1px solid rgba(118, 118, 118, 0.3)' }}>
                              <div className="center" onClick={() => handleRemoveRow(index)}>
                                {' '}
                                <RxCross1 size={15} />
                              </div>
                            </td>
                          ) : (
                            <td className="m-0 p-0" style={{ border: '1px solid rgba(118, 118, 118, 0.3)' }}>
                              <div className="center">
                                {' '}
                                <RxCross1 size={15} />
                              </div>
                            </td>
                          )}
                          <td className="m-0 p-0">
                            <input className="p-2" type="text" value={row?.srno} disabled style={{ width: '120px' }} />
                          </td>
                          <td className="m-0 p-0  itemCol">
                            {itemData?.pOrderNo === itemData?.requisitionNo ? (
                              <AsyncSelect
                                cacheOptions
                                value={{ value: row.ItemNo, label: row.ItemNo }}
                                options={itemOptions}
                                isDisabled={itemData?.eye === true ? true : false}
                                loadOptions={loadOptions}
                                onChange={(selectedOption) => handleInputChange(index, 'ItemNo', selectedOption.label)}
                                defaultOptions={itemOptions}
                                onMenuScrollToBottom={loadMoreOptions}
                                className="descSelect"
                                classNamePrefix="descSelect"
                              />
                            ) : (
                              <td className="m-0 p-0 itemCol">
                                <input className="p-2 w-100" disabled value={row?.ItemNo} />
                              </td>
                            )}
                          </td>
                          <td className="m-0 p-0 descriptionCol">
                            {itemData?.pOrderNo === itemData?.requisitionNo ? (
                              <AsyncSelect
                                cacheOptions
                                value={{ value: row.itemDescription, label: row.itemDescription }}
                                isDisabled={itemData?.eye === true ? true : false}
                                options={descriptionOptions}
                                loadOptions={loadDescOptions}
                                onChange={(selectedOption) => handleInputChange(index, 'itemDescription', selectedOption.label)}
                                className="descSelect"
                                classNamePrefix="descSelect"
                                defaultOptions={descriptionOptions}
                                onMenuScrollToBottom={loadMoreDescOptions}
                              />
                            ) : (
                              <td className="m-0 p-0 descriptionCol">
                                <input className="p-2 w-100" disabled value={row?.itemDescription} />
                              </td>
                            )}
                          </td>
                          <td className="m-0 p-0">
                            <input
                              className="p-2"
                              type="text"
                              disabled={itemData?.pOrderNo === itemData?.requisitionNo ? false : true}
                              value={row?.specification}
                              onChange={(e) => handleInputChange(index, 'specification', e.target.value)}
                              style={{ width: '350px' }}
                            />
                          </td>
                          <td className="m-0 p-0">
                            <input
                              className="p-2"
                              disabled={itemData?.pOrderNo === itemData?.requisitionNo ? false : true}
                              onWheel={(e) => e.target.blur()}
                              style={{ width: '120px' }}
                              type="number"
                              value={row?.qty}
                              onChange={(e) => handleInputChange(index, 'qty', e.target.value)}
                              onKeyDown={preventNegativeSign}
                            />
                          </td>
                          <td className="m-0 p-0">
                            <input className="p-2" disabled={true} type="text" value={row?.uom} style={{ width: '140px' }} />
                          </td>
                          <td className="m-0 p-0">
                            <input className="p-2" disabled type="text" value={row?.stock || 0} style={{ width: '140px' }} />
                          </td>
                          <td className="m-0 p-0">
                            <input
                              className="p-2"
                              disabled={itemData?.pOrderNo === itemData?.requisitionNo ? false : true}
                              onWheel={(e) => e.target.blur()}
                              style={{ width: '120px' }}
                              type="number"
                              value={row?.baseAmount}
                              onChange={(e) => handleInputChange(index, 'baseAmount', e.target.value)}
                              onKeyDown={preventNegativeSign}
                            />
                          </td>
                          <td className="m-0 p-0 itemCol">
                            <Select
                              className="flex-grow-1"
                              theme={(theme) => ({
                                ...theme,
                                padding: 10,
                              })}
                              value={{ value: row?.vatDec, label: row?.vatDec }}
                              options={vat?.map((vat) => ({ value: vat, label: vat?.description }))}
                              onChange={(selectedOption) => handleInputChange(index, 'vat', selectedOption.value)}
                            />
                          </td>
                          <td className="m-0 p-0">
                            <input
                              className="p-2"
                              type="text"
                              value={Number(row?.vatAmount || 0).toFixed(currencyPrecision)}
                              disabled
                              style={{ width: '120px' }}
                            />
                          </td>
                          <td className="m-0 p-0">
                            <input
                              className="p-2"
                              disabled
                              style={{ width: '120px' }}
                              type="text"
                              value={row.amount === NaN ? 0 : Number(row.amount || 0).toFixed(currencyPrecision) || 0}
                            />
                          </td>
                        </tr>
                      ))}
                </tbody>
              </table>
            )}
          </>
        ) : (
          <table className="po-item-grid-table">
            <thead className="dynoTable">
              <tr>
                <th className="po-item-grid-col-action"></th>
                <th className="po-item-grid-col-srno">Sr no</th>
                <th className="po-item-grid-col-itemno">Item No</th>
                <th className="po-item-grid-col-desc">Description</th>
                <th className="po-item-grid-col-specs">Item Specs</th>
                <th className="po-item-grid-col-qty">Qty</th>
                <th className="po-item-grid-col-uom">Packing UOM</th>
                <th className="po-item-grid-col-stock">Inventory Qty</th>
                <th className="po-item-grid-col-price">Unit Price</th>
                <th className="po-item-grid-col-vat">VAT %</th>
                <th className="po-item-grid-col-vatamt">VAT Amount</th>
                <th className="po-item-grid-col-amount">Amount</th>
              </tr>
            </thead>
            <tbody>
              {Array.isArray(rows) &&
                rows.map((row, index) => (
                  <tr key={index}>
                    {itemData?.requisitionNo ? (
                      <td className="m-0 p-0" style={{ border: '1px solid rgba(118, 118, 118, 0.3)' }}>
                        <div className="center">
                          {' '}
                          <RxCross1 size={15} />
                        </div>
                      </td>
                    ) : (
                      <td className="m-0 p-0" style={{ border: '1px solid rgba(118, 118, 118, 0.3)' }}>
                        <div onClick={() => handleRemoveRow(index)} className="center">
                          <RxCross1 size={15} />
                        </div>
                      </td>
                    )}
                    <td className="m-0 p-0">
                      <input className="p-2" type="text" value={row?.srno} disabled style={{ width: '80px' }} />
                    </td>
                    <td className="m-0 p-0 itemCol">
                      <AsyncSelect
                        cacheOptions
                        value={{ value: row.ItemNo, label: row.ItemNo }}
                        options={itemOptions}
                        loadOptions={loadOptions}
                        onChange={(selectedOption) => handleInputChange(index, 'ItemNo', selectedOption.label)}
                        defaultOptions={itemOptions}
                        onMenuScrollToBottom={loadMoreOptions}
                        className="descSelect"
                        classNamePrefix="descSelect"
                      />
                    </td>
                    <td className="m-0 p-0 descriptionCol">
                      <AsyncSelect
                        cacheOptions
                        value={{ value: row.itemDescription, label: row.itemDescription }}
                        options={descriptionOptions}
                        loadOptions={loadDescOptions}
                        onChange={(selectedOption) => handleInputChange(index, 'itemDescription', selectedOption.label)}
                        defaultOptions={descriptionOptions}
                        onMenuScrollToBottom={loadMoreDescOptions}
                        className="descSelect"
                        classNamePrefix="descSelect"
                      />
                    </td>
                    <td className="m-0 p-0">
                      <input
                        className="p-2"
                        type="text"
                        value={row?.specification}
                        onChange={(e) => handleInputChange(index, 'specification', e.target.value)}
                      />
                    </td>
                    <td className="m-0 p-0">
                      <input
                        className="p-2"
                        type="number"
                        onWheel={(e) => e.target.blur()}
                        value={row?.qty}
                        style={{ width: '90px' }}
                        onChange={(e) => handleInputChange(index, 'qty', e.target.value)}
                        onKeyDown={preventNegativeSign}
                      />
                    </td>
                    <td className="m-0 p-0">
                      <input className="p-2" disabled type="text" style={{ width: '140px' }} value={row?.uom} />
                    </td>
                    <td className="m-0 p-0">
                      <input className="p-2" disabled type="text" value={row?.stock || 0} style={{ width: '140px' }} />
                    </td>
                    <td className="m-0 p-0">
                      <input
                        className="p-2"
                        type="number"
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={preventNegativeSign}
                        value={row?.baseAmount}
                        style={{ width: '120px' }}
                        onChange={(e) => handleInputChange(index, 'baseAmount', e.target.value)}
                      />
                    </td>
                    <td className="m-0 p-0 itemCol">
                      <Select
                        className="descSelect"
                        classNamePrefix="descSelect"
                        theme={(theme) => ({
                          ...theme,
                          padding: 10,
                        })}
                        value={{ value: row?.vatDec, label: row?.vatDec }}
                        options={vat?.map((vat) => ({ value: vat, label: vat?.description }))}
                        onChange={(selectedOption) => handleInputChange(index, 'vat', selectedOption.value)}
                      />
                    </td>
                    <td className="m-0 p-0">
                      <input className="p-2" type="text" value={Number(row?.vatAmount || 0).toFixed(currencyPrecision)} disabled style={{ width: '120px' }} />
                    </td>
                    <td className="m-0 p-0">
                      <input
                        className="p-2"
                        style={{ width: '120px' }}
                        disabled
                        type="text"
                        value={row.amount === NaN ? 0 : Number(row.amount || 0).toFixed(currencyPrecision) || 0}
                        onChange={(e) => handleInputChange(index, 'amount', e.target.value)}
                      />
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        )}
        {itemData ? (
          <>
            {itemData?.eye === false ? (
              <>
                {' '}
                {itemData?.pOrderNo === itemData?.requisitionNo ? (
                  <div className="d-flex gap-5">
                    <button className="mainbtn  mt-4 gap-3" onClick={addNewRow}>
                      <div>Add</div> <IoAddSharp color="#fff" className="center mt-1 mx-2" />{' '}
                    </button>
                  </div>
                ) : (
                  ''
                )}
              </>
            ) : (
              ' '
            )}
          </>
        ) : (
          // !pendingOnlyMode && (
          <div className="d-flex gap-5">
            <button className="mainbtn  mt-4 gap-3" onClick={addNewRow}>
              <div>Add</div> <IoAddSharp color="#fff" className="center mt-1 mx-2" />{' '}
            </button>
          </div>
          // )
        )}
      </div>
      <div className="d-flex justify-content-between boxs">
        <div className="d-flex gap-2">
          <div className="totalhead center">Total Amount</div>
          <div className="field">{parseFloat(calculatedTotal)?.toFixed(currencyPrecision) || '---'}</div>
        </div>
        <div>
          <div className="totalhead center">_</div>
        </div>
        <div className="d-flex gap-2">
          <div className="totalhead center">Total Discount</div>
          <div className="field">{parseFloat(discountAmount)?.toFixed(currencyPrecision) || '---'}</div>
        </div>
        <div>
          <div className="totalhead center">=</div>
        </div>
        <div className="d-flex gap-2">
          <div className="totalhead center">After Discount</div>
          <div className="field">{(calculatedTotal - discountAmount)?.toFixed(currencyPrecision) || '---'}</div>
        </div>
        <div>
          <div className="totalhead center">+</div>
        </div>
        <div className="d-flex gap-2">
          <div className="totalhead center">Total Vat</div>
          <div className="field">{parseFloat(vatAmount)?.toFixed(currencyPrecision) || '---'}</div>
        </div>
        <div>
          <div className="totalhead center">=</div>
        </div>
        <div className="d-flex gap-2">
          <div className="totalhead center">Net Amount</div>
          <div className="field">{parseFloat(grandTotal)?.toFixed(currencyPrecision) || '---'}</div>
        </div>
      </div>
    </div>
  );
};

export default ItemGridTwo;
